<div>
    <div class="row">
        <div class="col-xs-12">
            <div class="title-box" *ngIf="!isDialogMode">
                <h2>Frequently Bought Together</h2>
            </div>

            <h3 *ngIf="isDialogMode" class="frequently-bought-together-small-title">
                Frequently Bought Together
            </h3>
        </div>
    </div>
    <div class="recommendations-container row">

        <ng-container *ngFor="let recommendation of selectableRecommendations; index as i">
            <div class="no-padding {{ recommendationsClass }}">
                <app-product-card
                    [product]="recommendation.product"
                    [isSelected]="recommendation.isSelected"
                    [showCheckbox]="true"
                    [showAddToCart]="false"
                    (onCheckedChange)="onSelectedChange(recommendation.webCode, $event)"
                    [source]="source"
                    [showSmallImages]="true"
                ></app-product-card>

                <div *ngIf="i !== recommendations.length - 1" class="frequently-bought-together-plus-sign hidden-xs">
                    <mdb-icon fas icon="plus"></mdb-icon>
                </div>
            </div>
        </ng-container>
        <div class="vcenter frequently-bought-together-total-price {{ addRecommendationsClass }}">
            <div *ngIf="numberOfSelected > 0">
                <span>Total: <strong>{{ totalPrice | currency }}</strong></span>
                    <button
                        type="button"
                        class="frequently-bought-together-add-to-cart mdkit-button btn-success bmd-ripple btn btn-sm"
                        [disabled]="numberOfSelected === 0"
                        (click)="addToCart()"
                    >add to cart
                    </button>
            </div>
            <div *ngIf="numberOfSelected === 0">Choose item(s) to buy together</div>
        </div>
    </div>
</div>